import React, { useState } from "react";
import InputField from "../../../library/components/InputField";
import { Validators } from "../../../library/utilities/Validator";
import backImage from '../../../images/back.png';
import './requestotp.css';
import Button from "../../../library/components/Button";
import { Link } from "react-router-dom";
import PasswordField from "../../../library/components/Password";

function RequestOtpForm({ role, loginObj, setLoginObj, exceedError, resetPassword ,Error ,setError  }) {

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };
  // const state = location.state;

  // const exceedError = state ? state.exceed : null;

  // const resetPassword = state ? state.reset : null;

  // const handleChange = (key, event) => {
  //   setLoginObj({ ...loginObj, [key]: event });
  // };
  const handleChange = (key, value) => {
    setLoginObj({ ...loginObj, [key]: value });
  };
  return (
    <div className="">
    

      {(localStorage.firstLogin === "M" || localStorage.first_role !== "blo")?"" :
      //  ||
      // localStorage.first_role === "aero") ? "" :
      <div className="row p-2">
        <InputField
          label="User Id"
          // maxLength="100"
          placeholder="userId"
          name="userId"
          required={true}
            iconclass="fas fa-envelope"
            inputClass="col-md-12 forminputLogin"
            labelClass="col-md-12 d-none"
          value={loginObj.userId}
          onChange={(val) => handleChange("userId", val)}
          getError={(value) => getError("userId", value)}
          validators={[
            // {
            //   check: Validators.textinput,
            //   message: "Please enter valid first name",
            // },
            {
              check: Validators.required,
              message: "This field is required",
            },
          ]} 
          Error={Error}
        />
      </div>
      }
      <div className="row pl-2 pr-2">
        <PasswordField
          label="Password"
          name="password"
          placeholder="Password"
          required={true}
          onDrop={true}
          onCopy={true}
          onCut={true}
          autoComplete={"off"}
           iconclass="fas fa-eye"
          inputClass="col-md-12 forminputLogin"
          labelClass="col-md-12 d-none"
          value={loginObj.password}
          onChange={(val) => handleChange("password", val)}
          getError={(value) => getError("password", value)}
          validators={[
            {
              check: Validators.passwordupper,
              message: "Atleast one uppercase required",
            },
            {
              check: Validators.passworddigit,
              message: "Atleast one digit required",
            },
            {
              check: Validators.passwordspecial,
              message: "Atleast one valid special character(@ , _ - ! # .) required",
            },
            {
              check: Validators.passwordmin,
              message: "Atleast eight characters required",
            },
            {
              check: Validators.required,
              message: "This field is required",
            },
          ]}
          Error={Error}
        />
      </div>

         <div className="row pl-2 pr-2">
        <small className="col-md-12">
          Password should contain the following,
          <ul>
            <li>At least Eight Characters</li>
            <li>At least One Capital Letter (A-Z)</li>
            <li>At least One Number (0-9)</li>
            <li>At least One Special Character (.!@$%^&*()_+-=)</li>
            <li>Should not contain any space</li>
            <li>Should be different from last five used passwords</li>
          </ul>
        </small>
      </div>
      
      <div className="row pl-2 pr-2">
        <PasswordField
          label="Confirm Password"
          name="confirmpassword"
          placeholder="Confirm Password"
          required={true}
          onDrop={true}
          onCopy={true}
          onCut={true}
          autoComplete={"off"}
           iconclass="fas fa-eye"
          inputClass="col-md-12 forminputLogin"
          labelClass="col-md-12 d-none"
          value={loginObj.confirmpassword}
          onChange={(val) => handleChange("confirmpassword", val)}
          getError={(value) => getError("confirmpassword", value)}
          validators={[
            {
              check: Validators.required,
              message: "This field is required",
            },
          ]}
          Error={Error}
        />
      </div>
      <Button
        btnClass="btn-block submit1 btnpurple"
        value={`${exceedError || resetPassword ? "Login" : "submit"}`}
        onClick={() => { }}
        type="submit"
      />
       {exceedError && (
        <div className="displayMessage">
          You cannot login. You have exceeded the maximum limit. Please try
          again tomorrow.
        </div>
      )}
      {resetPassword && (
        <div className="displayMessage">
          Time to reset your password, by clicking the Forgot Password button
          below.
        </div>
      )}
    </div>
  );
}

export default RequestOtpForm;
